import React from "react";
import PropTypes from "prop-types";
import {
  Paper,
  Typography,
  Grid,
  LinearProgress,
  Box,
  makeStyles,
} from "@material-ui/core";

// TZ-786 Step 5: school-wide rollup of the three activation counters.
// Sits at the top of the Activation page above the per-team table.
// Numbers come straight from /activation_stats `summary`; the bar is a
// visual aid so admins can eyeball the ratio without reading the
// numbers. Hidden when total is 0 because the bar's percentage isn't
// meaningful — the empty state is handled by the parent page.

const useStyles = makeStyles((theme) => ({
  paper:         { padding: 24, marginBottom: 24 },
  successValue:  { color: theme.palette.success.main },
  errorValue:    { color: theme.palette.error.main },
  progress:      { height: 8, borderRadius: 4, marginTop: 4 },
}));

const ActivationSummary = ({ summary }) => {
  const classes = useStyles();
  const { total, activated, unactivated } = summary;
  const pct = total > 0 ? Math.round((activated / total) * 100) : 0;

  return (
    <Paper className={classes.paper}>
      <Typography variant="h6" gutterBottom>
        School activation overview
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Typography variant="body2" color="textSecondary">Roster total</Typography>
          <Typography variant="h4">{total}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" color="textSecondary">Activated</Typography>
          <Typography variant="h4" className={classes.successValue}>{activated}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" color="textSecondary">Unactivated</Typography>
          <Typography variant="h4" className={classes.errorValue}>{unactivated}</Typography>
        </Grid>
      </Grid>

      {total > 0 && (
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            {pct}% activated
          </Typography>
          <LinearProgress
            variant="determinate"
            value={pct}
            className={classes.progress}
          />
        </Box>
      )}
    </Paper>
  );
};

ActivationSummary.propTypes = {
  summary: PropTypes.shape({
    total:       PropTypes.number.isRequired,
    activated:   PropTypes.number.isRequired,
    unactivated: PropTypes.number.isRequired,
  }).isRequired,
};

export default ActivationSummary;
